import { Timestamp } from "firebase/firestore";
import { INewPeriod } from "../interfaces/new-period.interface";
import { IPeriod } from "../interfaces/period.interface";
import { createPeriod, updatePeriod } from "../services/firestore.service";
import { useAppDispatch } from "../hooks";
import { dismiss } from "../slices/dialogsSlice";

interface EditPeriodDialogProps {
    period: IPeriod;
    projectId: string;
    categoryId: string;
    updatePeriods: () => void;
    dialogId: number;
}

export const EditPeriodDialog = ({
    period,
    projectId,
    categoryId,
    updatePeriods,
    dialogId,
}: EditPeriodDialogProps) => {
    const dispatch = useAppDispatch();

    const getInitialDate = (): string => {
        const startDate = new Date(period.startDateTime.toDate());
        let year: string = startDate.getFullYear() + "";
        let month: string = startDate.getMonth() + 1 + "";
        month = month.length === 1 ? "0" + month : month;
        let date: string = startDate.getDate() + "";
        date = date.length === 1 ? "0" + date : date;

        return `${year}-${month}-${date}`;
    };

    const getTime = (timestamp?: Timestamp): string => {
        if (!timestamp) return "";

        const tsDate = new Date(timestamp.toDate());
        let hour: string = tsDate.getHours() + "";
        hour = hour.length === 1 ? "0" + hour : hour;
        let minute: string = tsDate.getMinutes() + "";
        minute = minute.length === 1 ? "0" + minute : minute;

        return `${hour}:${minute}`;
    };

    const duplicate = (e) => {
        e.preventDefault();

        let data = new FormData(e.target);

        let date = data.get("date").toString();
        let startTime = data.get("start-time").toString();
        let endTime = data.get("end-time").toString();

        let startTimestamp = Date.parse(`${date}T${startTime}`);
        let endTimestamp = !!endTime ? Date.parse(`${date}T${endTime}`) : null;

        if (isNaN(startTimestamp)) {
            return;
        }

        let startDate = new Date(startTimestamp);
        let endDate = isNaN(endTimestamp) ? null : new Date(endTimestamp);

        let newPeriod: INewPeriod = {
            title: data.get("title").toString(),
            startDateTime: new Timestamp(startDate.getTime() / 1000, 0),
            endDateTime: !endDate ? null : new Timestamp(endDate.getTime() / 1000, 0),
            chargable: !!data.get("chargable"),
            assignedTo: data.get("assigned-to").toString(),
        };

        createPeriod(projectId, categoryId, newPeriod).then(() => {
            updatePeriods();
            close();
        });
    };

    const savePeriod = (e) => {
        e.preventDefault();

        let data = new FormData(e.target);

        if (e.nativeEvent.submitter.value) {
            duplicate(e);
            return;
        }

        let date = data.get("date").toString();
        let startTime = data.get("start-time").toString();
        let endTime = data.get("end-time").toString();

        let startTimestamp = Date.parse(`${date}T${startTime}`);
        let endTimestamp = !!endTime ? Date.parse(`${date}T${endTime}`) : null;

        if (isNaN(startTimestamp)) {
            return;
        }

        let startDate = new Date(startTimestamp);
        let endDate = isNaN(endTimestamp) ? null : new Date(endTimestamp);

        let newPeriod: IPeriod = {
            id: period.id,
            title: data.get("title").toString(),
            startDateTime: new Timestamp(startDate.getTime() / 1000, 0),
            endDateTime: !endDate ? null : new Timestamp(endDate.getTime() / 1000, 0),
            chargable: !!data.get("chargable"),
            assignedTo: data.get("assigned-to").toString(),
        };

        updatePeriod(projectId, categoryId, newPeriod).then(() => {
            updatePeriods();
            close();
        });
    };

    const close = () => {
        dispatch(dismiss(dialogId));
    };

    return (
        <>
            <form onSubmit={savePeriod}>
                <h1>Edit Period</h1>

                <input placeholder="Title" name="title" defaultValue={period.title} />
                <input placeholder="Date" name="date" type="date" defaultValue={getInitialDate()} />
                <input
                    placeholder="Start"
                    name="start-time"
                    type="time"
                    defaultValue={getTime(period.startDateTime)}
                    step="00:15"
                />
                <input
                    placeholder="End"
                    name="end-time"
                    type="time"
                    defaultValue={getTime(period.endDateTime)}
                    step="00:15"
                />

                <div className="checkbox-container">
                    <input
                        defaultChecked={period.chargable}
                        id="chargable"
                        name="chargable"
                        type="checkbox"
                    />
                    <label htmlFor="chargable">Chargable</label>
                </div>

                <select name="assigned-to" defaultValue={period.assignedTo}>
                    <option value="" disabled>
                        Assigned To
                    </option>
                    <option value="Daryl">Daryl</option>
                    <option value="Josh">Josh</option>
                </select>

                <button type="submit">Save</button>

                <button type="submit" name="action" value="duplicate">
                    Duplicate
                </button>
            </form>

            <button className="warn" onClick={close}>
                Cancel
            </button>
        </>
    );
};
